import { useEffect } from "react";
import { useCarFilterStore } from "@/store/carFilterStore";

interface CategoryTabsProps {
  activeCategory: number;
  onCategoryChange: (index: number) => void;
}

export default function CategoryTabs({
  activeCategory,
  onCategoryChange,
}: CategoryTabsProps) {
  const categories = useCarFilterStore((state) => state.categories);
  const isLoading = useCarFilterStore((state) => state.isLoading);
  const loadFilters = useCarFilterStore((state) => state.loadFilters);

  useEffect(() => {
    loadFilters();
  }, [loadFilters]);

  // 全部选项在最前面
  const allCategories = [{ car_type: "全部", count: 0 }, ...categories];

  return (
    <div
      className="flex gap-2 mt-5 px-4 pb-3 overflow-x-auto"
      style={{ scrollbarWidth: "none" }}
    >
      {isLoading ? (
        <span className="text-xs text-gray-400 py-1.5">加载中...</span>
      ) : (
        allCategories.map((cat, i) => (
          <button
            key={cat.car_type}
            onClick={() => onCategoryChange(i)}
            className="flex-shrink-0 px-3.5 py-1.5 rounded-full text-xs font-medium cursor-pointer whitespace-nowrap transition-all"
            style={{
              background: activeCategory === i ? "#1E3A8A" : "#F3F4F6",
              color: activeCategory === i ? "#fff" : "#6B7280",
            }}
          >
            {cat.car_type}
          </button>
        ))
      )}
    </div>
  );
}
